import { CANDIDATES } from 'constants/api';
import axios from 'utils/axios';

export const getCandidates = async (params = {}) => {
    try {
        const result = await axios.get(CANDIDATES.v1.baseUrl, { params });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get candidates');
    }
};

export const getCandidate = async (id, params = {}) => {
    try {
        const result = await axios.get(`${CANDIDATES.v1.baseUrl}/${id}`, { params });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get candidate');
    }
};

export const getCandidateEvidenceLibrary = async (id, { status = 'active' } = {}) => {
    try {
        const result = await axios.get(`${CANDIDATES.v1.baseUrl}/${id}/evidence-library`, { params: { status } });
        return result.data;
    } catch (err) {
        throw new Error(err?.response?.data?.message || err?.message || 'Failed to get candidate evidence library');
    }
};

export const deleteCandidateEvidenceLibraryFile = async (candidateId, assessmentCode, evidenceId) => {
    try {
        const result = await axios.delete(
            `${CANDIDATES.v1.baseUrl}/${candidateId}/evidence-library/${encodeURIComponent(assessmentCode)}/evidence/${encodeURIComponent(
                evidenceId
            )}`
        );
        return result.data;
    } catch (err) {
        throw new Error(err?.response?.data?.message || err?.message || 'Failed to delete evidence file');
    }
};

export const getCandidateEvidenceLibraryAccessUrl = async (candidateId, assessmentCode, evidenceId, mode = 'preview') => {
    try {
        const result = await axios.get(
            `${CANDIDATES.v1.baseUrl}/${candidateId}/evidence-library/${encodeURIComponent(assessmentCode)}/evidence/${encodeURIComponent(
                evidenceId
            )}/access-url`,
            { params: { mode } }
        );
        return result.data;
    } catch (err) {
        throw new Error(err?.response?.data?.message || err?.message || 'Failed to create evidence access URL');
    }
};

export const updateCandidate = async (id, data = {}) => {
    try {
        const result = await axios.patch(`${CANDIDATES.v1.baseUrl}/${id}`, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to update candidate');
    }
};
